import { Component, input } from '@angular/core';
import { Tiltak } from "../../../../models/oppsummering.model";

@Component({
  selector: 'bko-beskrivelse',
  imports: [],
  templateUrl: './beskrivelse.html',
  styleUrl: './beskrivelse.scss'
})
export class Beskrivelse {
  tiltak = input.required<Tiltak>();
}
